import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { Radio } from './Radio';
import { Flex } from '../grid/Grid';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
`;

const ChildrenWrapper = styled(Flex).attrs({
  flexWrap: 'wrap',
})`
  width: 100%;
  margin-bottom: -8px;
`;

const getOptions = options =>
  options.map(option =>
    typeof option === 'string'
      ? {
          label: option,
          value: option,
        }
      : option
  );

export const Group = ({
  name,
  value,
  defaultValue,
  onChange,
  disabled,
  options,
  children,
  itemStyle,
  itemsWrapperStyle,
}) => {
  const [checkedValue, setCheckedValue] = useState(value || defaultValue || undefined);

  const onOptionChange = useCallback(
    e => {
      // if pass value, we do not modify checkedValue directly
      if (!value && e.target.value !== checkedValue) {
        setCheckedValue(e.target.value);
      }

      if (onChange && e.target.value !== checkedValue) {
        onChange(e.target.value);
      }
    },
    [value, checkedValue, onChange]
  );

  if (value && value !== checkedValue) {
    setCheckedValue(value);
  }

  const childrenForRender =
    options && options.length > 0
      ? getOptions(options).map(option => (
          <Radio
            key={option.value}
            name={name}
            disabled={option.disabled || disabled}
            value={option.value}
            checked={checkedValue === option.value}
            onChange={onOptionChange}
            {...itemStyle}
          >
            {option.label}
          </Radio>
        ))
      : React.Children.map(children, child =>
          React.cloneElement(child, {
            name: name,
            key: child.props.value,
            checked: checkedValue === child.props.value,
            onChange: onOptionChange,
            ...itemStyle,
          })
        );

  return (
    <Wrapper>
      <ChildrenWrapper {...itemsWrapperStyle}>{childrenForRender}</ChildrenWrapper>
    </Wrapper>
  );
};

Group.defaultProps = {
  options: [],
  itemsWrapperStyle: {},
  itemStyle: {
    mr: '4px',
    mb: '8px',
  },
};
